import { useEffect, useRef, useState } from 'react';

/**
 * True while a highlight is travelling to a new target. Holding the moving
 * state through the CSS transition matters for controlled components: their
 * primitive can render again immediately after an external value change
 * (Reset and Shuffle do this), which used to remove the transition class and
 * snap the highlight to its destination.
 */
export function useGlide(key) {
  const active = key == null || key === '' ? null : key;
  const prev = useRef(null);
  const timer = useRef(0);
  const [moving, setMoving] = useState(false);
  const changed = prev.current !== null && active !== null && prev.current !== active;

  useEffect(() => {
    prev.current = active;
    window.clearTimeout(timer.current);
    if (changed) {
      setMoving(true);
      timer.current = window.setTimeout(() => setMoving(false), 180);
    } else if (active === null) {
      setMoving(false);
    }
    return () => window.clearTimeout(timer.current);
  }, [active]);

  return active !== null && (changed || moving);
}

export function boxesEqual(a, b) {
  return !!a && !!b && a.x === b.x && a.y === b.y && a.w === b.w && a.h === b.h;
}
